export const calculateAnnualSavings = (energyBaseline = {}, potentialSavings = 0) => {
  if (energyBaseline && energyBaseline.annualElectricityCost) {
    const conservative = Math.round(energyBaseline.annualElectricityCost * 0.15);
    const aggressive = Math.round(energyBaseline.annualElectricityCost * 0.25);
    return { conservative, aggressive };
  }

  return {
    conservative: potentialSavings * 0.8,
    aggressive: potentialSavings * 1.2
  };
};

export const calculatePaybackMonths = (conservativeAnnualSavings, reportPrice = 990) =>
  Math.round((reportPrice / (conservativeAnnualSavings / 12)) * 10) / 10;


